export const LANGS = ['es', 'en', 'pt'] as const;
export type Lang = (typeof LANGS)[number];
export const DEFAULT_LANG: Lang = 'es';

/**
 * Translation resources contributed by the core or by one feature module:
 * `{ es: { agents: {...} }, en: { agents: {...} }, pt: { agents: {...} } }`.
 * Namespaces are merged across bundles by `createI18n`.
 */
export type I18nBundle = Record<Lang, Record<string, object>>;

/** Builds a bundle for a single namespace from its three language files. */
export const namespaceBundle = (
  ns: string,
  resources: Record<Lang, object>,
): I18nBundle => ({
  es: { [ns]: resources.es },
  en: { [ns]: resources.en },
  pt: { [ns]: resources.pt },
});

/** Merges several single-namespace bundles into one module bundle. */
export const mergeBundles = (...bundles: I18nBundle[]): I18nBundle => {
  const merged: I18nBundle = { es: {}, en: {}, pt: {} };
  for (const bundle of bundles) {
    for (const lang of LANGS) {
      Object.assign(merged[lang], bundle[lang]);
    }
  }
  return merged;
};
